import { render, staticRenderFns } from "./pc-checkbox-button.vue?vue&type=template&id=4359e217&scoped=true&"
import script from "./pc-checkbox-button.vue?vue&type=script&lang=js&"
export * from "./pc-checkbox-button.vue?vue&type=script&lang=js&"
import style0 from "./pc-checkbox-button.vue?vue&type=style&index=0&id=4359e217&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4359e217",
  null
  
)

export default component.exports